import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { Trans } from '@libs/i18n';

export const HomePage: FC = observer(() => {
  return <div><Trans i18nKey={'home.title'} /></div>;
});
